import IconsCompontent from './iconPicker.vue'
const Icons = {
  install(Vue) {
    Vue.component('ui-icons', IconsCompontent);
  }
}
export default Icons;



// WEBPACK FOOTER //
// ./src/components/IconPicker/index.js